import { render, staticRenderFns } from "./course-detail.vue?vue&type=template&id=5fd70306&"
import script from "./course-detail.vue?vue&type=script&lang=js&"
export * from "./course-detail.vue?vue&type=script&lang=js&"
import style0 from "./course-detail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports